import KeyMirror from 'keymirror';

const UserType = KeyMirror({
	GET_LIST_USER: null,
	CREATE_USER: null,
	UPDATE_USER: null,
	HIDE_USER: null,
	DELETE_USER: null,
});

export default UserType;
